/* Bedtextielonline (Claude, okt 2026): werking van de kleurbolletjes op de productkaarten.
   Stond vroeger als los scriptje in elke productkaart (36x per pagina); nu één keer, als bestand.
   - kies je een ander bolletje, dan gaan de links en de titel van de kaart mee naar die kleur
   - de knop +X toont de verborgen kleuren. Die verborgen bolletjes krijgen pas dan hun foto-info
     (opgehaald uit /products/<handle>.js), zodat de pagina zelf veel lichter blijft. */
(function () {
  if (window.__btolSiblingSwatch) return;
  window.__btolSiblingSwatch = true;

  function compact(m) {
    if (!m || !m.preview_image) return null;
    return JSON.stringify({
      alt: m.alt || '',
      preview_image: { src: m.preview_image.src, width: m.preview_image.width, height: m.preview_image.height }
    });
  }

  /* foto-info aanvullen voor bolletjes die ze nog niet hebben */
  function vulAan(card) {
    card.querySelectorAll('input[data-sibling-url]:not([data-variant-media])').forEach(function (input) {
      var url = (input.getAttribute('data-sibling-url') || '').split('?')[0];
      if (!url) return;
      fetch(url + '.js', { credentials: 'same-origin' })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (p) {
          if (!p || !p.media || !p.media.length) return;
          var eerste = compact(p.media[0]);
          var tweede = compact(p.media[1]);
          if (eerste) input.setAttribute('data-variant-media', eerste);
          if (tweede) input.setAttribute('data-variant-secondary-media', tweede);
        })
        .catch(function () {});
    });
  }

  document.addEventListener('change', function (event) {
    var input = event.target;
    if (!input.matches || !input.matches('input[data-sibling-url]')) return;

    var card = input.closest('product-card');
    if (!card) return;

    card.querySelectorAll('a.product-card__media, a.product-title').forEach(function (link) {
      link.setAttribute('href', input.getAttribute('data-sibling-url'));
    });

    var titleLink = card.querySelector('a.product-title');
    if (titleLink && input.getAttribute('data-sibling-title')) {
      titleLink.textContent = input.getAttribute('data-sibling-title');
    }

    var quickBuy = card.querySelector('.product-card__quick-add-button');
    if (quickBuy) {
      quickBuy.style.display = input.hasAttribute('data-sibling-current') ? '' : 'none';
    }
  });

  document.addEventListener('click', function (event) {
    var moreButton = event.target.closest('.btol-swatch-more');
    if (!moreButton) return;

    event.preventDefault();

    var card = moreButton.closest('product-card');
    if (!card) return;

    card.querySelectorAll('.btol-swatch-hidden').forEach(function (el) {
      el.classList.remove('btol-swatch-hidden');
    });

    vulAan(card);
    moreButton.remove();
  });
})();
